import CommonFoundationsEvents from "./common/CommonFoundationsEvents";
import { Container } from "@mui/material";

const FoundationsPage = () => {
    return (
        <div style={{ paddingTop: "4rem" }}>
            <Container maxWidth="xxl">
                <CommonFoundationsEvents />
            </Container>
        </div>
    )
};

export default FoundationsPage